export enum OauthErrorCodeEnum {
    // 请求接口带的customerId不在登录的账号里
    MISS_MATCH_CUSTOMER_ID = 'miss_match_customer_id'
}

export enum CustomerErrorCodeEnum {
    // 权限开通 重复提交
    APPLICATION_PRODUCT_DUPLICATE_SUBMIT = 13111,
    // 打回 重复提交
    MODIFY_DUPLICATE_SUBMIT = 13111,
    // 修改资料 重复提交
    UPDATE_DUPLICATE_SUBMIT = 13111,
    // SSN号被绑定账号了
    SSN_ALREADY_ASSOCIATED = 13031,
    IDNO_CHECK_FAILED = 120001
}
